<template>
    <div id="product-price-table" :data-shortcut-title="$t('general.prices.title')" class="w-full">
        <div class="rounded-lg bg-white md:border md:border-border md:p-6">
            <div class="flex items-center justify-between">
                <span class="text-2xl font-extrabold md:font-black" v-text="$t('general.prices.title')" />

                <DiscountBadge :discount="productPageStore.configurableProduct.discount" size="xl" />
            </div>

            <div class="space-y-5">
                <ProductPriceTableProductGroup
                    v-for="(productGroup, index) in productGroups"
                    :key="`price_table_group_${index}`"
                    :group-title="index as string"
                    :product-groups="productGroup"
                    :show-group-title="Object.keys(productGroups).length > 1"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import DiscountBadge from '@/components/badges/DiscountBadge.vue';
import { filterPriceTableProducts } from '@/lib/products/priceTable';
import ProductPriceTableProductGroup from '@/pages/product-page/partials/product-price-table/ProductPriceTableProductGroup.vue';
import { useProductPageStore } from '@/stores/pages/ProductPageStore';
import { useProductStore } from '@/stores/products/ProductStore';
import type { ConfigurableProductProductObject } from '@/types/generated';
import _ from 'lodash';
import { computed } from 'vue';

const productPageStore = useProductPageStore();
const productStore = useProductStore();

// Narrowed by the product page filters the magento group picked for the price table.
const allProducts = computed(() =>
    filterPriceTableProducts(
        productPageStore.configurableProduct.configurable_product_products,
        productPageStore.configurableProduct.price_table_filters,
        productStore.activeAttributeValues,
    ),
);

const hasFeaturedProducts = computed(() => allProducts.value.some((cpp: ConfigurableProductProductObject) => cpp.metadata.is_featured));

// Mirror Magento 2: when featured products exist, only show those in the price table
const productGroups = computed(() =>
    _(allProducts.value)
        .filter((cpp: ConfigurableProductProductObject) => !_.isNil(cpp.metadata.price_table_entry))
        .filter((cpp: ConfigurableProductProductObject) => !hasFeaturedProducts.value || cpp.metadata.is_featured)
        .groupBy((cpp: ConfigurableProductProductObject) => cpp.metadata.price_table_entry?.group_title)
        .value(),
);
</script>
